<template>
  <div class="pickupContainer" :style="cssProps" @click="startAndStopPlayback">
    <div class="fixedContainerSingle">
      <img :src="recordImage" v-bind:class="rotate" :style="cssProps">
    </div>
    <div class="fixedContainerArm" :style="cssProps">
      <div v-bind:class="arm_wiggle">
        <img :src="pickupArmImage" v-bind:class="arm_rotate" :style="cssProps"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pickup",
  props : {
    recordImage: {
      type: String, required: true
    },
    pickupArmImage: {
      type: String, default: "./frail-assets/pickup-arm.png"
    },
    pickupSize: {
      type: Number,
      default: 0.5
    },
    recordLength: {
      type: Number,
      default: 10
    },
    audioFile: {
      type: String, required: true
    }
  },
  data: function() {
    return {
      rotate: "rotate-off",
      arm_rotate: "arm-rotate-off",
      arm_wiggle: "arm-wiggle-off",
      recordTimer: null,
      audioStartTimer: null,
      audio: new Audio(this.audioFile)
    }
  },
  methods: {
    startAndStopPlayback: function (){
      clearTimeout(this.recordTimer);
      clearTimeout(this.audioStartTimer);
      this.recordTimer = setTimeout( () => {
        this.rotate = "rotate-off";
        this.arm_wiggle = "arm-wiggle-off";
        this.arm_rotate = "arm-rotate-off";
        if (this.audio){
          this.audio.pause();
        }
      }, this.correctedRecordLength*1000)
      if (this.rotate == "rotate") {
        this.rotate = "rotate-off";
        this.audio.pause();
      }
      else {
        this.rotate = "rotate";
        this.audio.load();
        this.audioStartTimer = setTimeout(()=>{
          this.audio.play();
        }, Math.max(this.recordLength * 5, 1500));
      }
      if (this.arm_rotate == "arm-rotate") this.arm_rotate = "arm-rotate-off"
      else this.arm_rotate = "arm-rotate"
      if (this.arm_wiggle == "arm-wiggle") this.arm_wiggle = "arm-wiggle-off"
      else this.arm_wiggle = "arm-wiggle"
    }
  },
  computed: {
    // audio starts Math.max(this.recordLength * 0.005, 1.5) * 1000 later to allow arm to arrive at turntable
    // also adds 1s margin to ensure audio playback will not be truncated due to streaming issues f.e.
    correctedRecordLength(){
      return this.recordLength + Math.max(this.recordLength * 0.005, 1.5) + 1 //
    },
    cssProps() {
      return {
        '--record-width' : this.pickupSize * 1000 + "px",
        '--record-height' : this.pickupSize * 1000 + "px",
        '--arm-width' : this.pickupSize * 250 + "px",
        '--arm-height' : this.pickupSize * 800 + "px",
        '--arm-margin-left': (this.pickupSize * 250) * 3.6 + "px",
        '--pickup-width' : this.pickupSize * 1100 + "px",
        '--pickup-height' : this.pickupSize * 1100 + "px",
        '--corrected-record-length' : this.correctedRecordLength + "s"
      }
    }
  }
}
</script>

<style scoped>
.pickupContainer {
  position: relative;
  height: var(--pickup-height);
  width: var(--pickup-width);
  cursor: pointer;
  margin: auto;
}

@media (-moz-touch-enabled: 0), (pointer: fine) {
  .pickupContainer:hover .arm-rotate-off {
    transform-origin: 50% 5%;
    transform: rotate(3deg);
    transition: 1s all ease-in-out;
  }
}

.buttonContainer {
  position: relative;
  min-height: 50px;
  margin-bottom: 10px;
}
.rotate {
  width: var(--record-width);
  height: var(--record-height);
  animation: rotation 2s infinite linear;
}
.rotate-off {
  width: var(--record-width);
  height: var(--record-height);
}

.arm-rotate {
  width: var(--arm-width);
  height: var(--arm-height);
  animation: arm-rotate var(--corrected-record-length) ease-in;
  transform-origin: 50% 5%;
  transition: 1s transform ease-in-out;
}
.arm-rotate-off {
  width: var(--arm-width);
  height: var(--arm-height);
  transform-origin: 50% 5%;
  transform: rotate(0deg);
  transition: 1s transform ease-in-out;
}

.arm-wiggle {
  animation: arm-wiggle 2s infinite ease-in-out;
  transform-origin: 50% 5%;
}

.fixedContainerSingle {
  position: absolute;
  margin-left: 0%;
  margin-top: 0%;
}

.fixedContainerArm {
  position: absolute;
  margin-left: var(--arm-margin-left);
  margin-top: 0%;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

@keyframes arm-rotate {

  0% {
    transform: rotate(3deg);
  }
  0.4% {
    transform: rotate(8deg);
  }
  95% {
    transform: rotate(20deg);
  }
  100% {
    transform: rotate(24deg);
  }
}

@keyframes arm-wiggle {
  33% {
    transform: rotate(0.3deg);
  }
  66% {
    transform: rotate(-0.3deg);
  }
  100%{
    transform: rotate(0deg);
  }
}
</style>